const appName = 'canva'
const titleAppName = 'Canva'
const googleAnalyticsId = 'G-BT15SXH30Q'

export const baseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://hs-canva.herokuapp.com'
    : 'http://localhost:5000'

//`${baseUrl}/api/vendor/oauth/redirect`
export const redirectUri = encodeURIComponent(
  `${baseUrl}/api/vendor/oauth/redirect`
)

const config = {
  googleAnalyticsId,
  app: appName,
  settingsLinks: [
    { text: 'Help', href: 'https://hootsuite.com/help' },
    { text: 'Feedback', href: 'https://jodychambers.typeform.com/to/F8GWdP' },
    { text: 'Developer', href: 'https://jmoneyapps.com' },
    {
      text: 'User Guide',
      href: `https://jmoneyapps.com/hootsuite/user-guide/${appName}`,
    },
  ],
  vendor: {
    name: {
      lowerCase: appName,
      titleCase: titleAppName,
    },
    login: {
      url: ``,
    },
    register: {
      url: `https://${appName}.com/`,
    },
    apiUrl: '',
    apiKey: 'FgaSmUUbfiyTdaxQT_a5ORXF',
  },
  hs: {
    secret: 'RuN4Money',
  },
}

export default config
